/* eslint-disable no-unused-vars */
import React from "react"
import { HeaderPersonalInformation, HeaderFilters } from ".."

export const Header = ({ customer, report }) => {
  return (
    <>
      <HeaderPersonalInformation customer={customer} />
      <HeaderFilters report={report} />
    </>
  )
}
